export const SET_ACTIVITIE = 'GUIDE/ACTIVITIE/SET_ACTIVITIE'
export const SET_ACTIVITIES = 'GUIDE/ACTIVITIE/SET_ACTIVITIES'
